import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Payment, PaymentDetail } from "../../../../interfaces/Purchases/Payments/payments";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { useTranslation } from "react-i18next";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import GenericPromises from "../../../../api/GenericPromises";
import { useDates } from "../../../../hooks/useDates";
import { useFormatNumber } from "../../../../hooks/useFormatNumber";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useFiles } from "../../../../hooks/useFiles";
import { File } from "../../../../interfaces/Commons/files";
import Swal from "sweetalert2";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../components/Header";
import { Backdrop, Box, Button, CircularProgress, ListItemButton, Popover, TextField, Typography } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import EmailIcon from '@mui/icons-material/Email';
import PrintIcon from '@mui/icons-material/Print';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { StampingPayment } from "../commons/stamping";
import { DialogSendEmailPayment } from "../helpers/dialogSendEmailPayment";
import { TabStatuses } from "./tabStatuses";
import { TabRelatedDocuments } from "./tabRelatedPaymentsDetails";
import DialogPaymentDetail from "./tabPaymentDetail";
import { Divider } from "../../../../components/Commons/Divider";
import { DialogCancelPayment } from "./components/dialogCancelPayment";
import { useTheme } from '@mui/material/styles';
import { PaymentsPDF } from "../../../../reports/paymentsPDF/PaymentsPDF";
import { useFormulaEvaluator } from "../../../../hooks/useFormulaEvaluator";
import { usePdf } from "../../../../hooks/usePdf";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { toast } from "react-toastify";

type ViewPaymentDetailsProps = {
  paymentDetailPayload: PaymentDetail;
  setOpenDialogView: Dispatch<SetStateAction<boolean>>;
  permissionsPaymentsDetails?: Menuitem;
  permissionsPayments?: Menuitem;
  setClickedButtonGoBack: Dispatch<SetStateAction<boolean>>;
}

export const ViewPaymentDetails = ({
  paymentDetailPayload,
  setOpenDialogView,
  permissionsPaymentsDetails,
  permissionsPayments,
  setClickedButtonGoBack,
}: ViewPaymentDetailsProps) => {
  const [t] = useTranslation("global");
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const { GenericGetResource, GenericPatchResource, GenericGetReport, GenericPutResource } = GenericPromises();
  const { TimeConverter } = useDates();
  const { setFormatNumber } = useFormatNumber();
  const { GetResourceByUrl } = usePermissions();
  const theme = useTheme();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [loadedStampingInfo, setLoadedStampingInfo] = useState(false);
  const [openDialogCancelPayment, setOpenDialogCancelPayment] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [anchorEl1, setAnchorEl1] = useState<HTMLButtonElement | null>(null);
  const [anchorEl2, setAnchorEl2] = useState<HTMLButtonElement | null>(null);
  const [resourceGeneratePdf, setResourceGeneratePdf] = useState<Menuitem>();
  const [resourceResetPdf, setResourceResetPdf] = useState<Menuitem>();
  const [resourceCancelPayment, setResourceCancelPayment] = useState<Menuitem>();
  const [resourceSendEmail, setResourceSendEmail] = useState<Menuitem>();
  const [paymentLocal, setPaymentLocal] = useState<Payment>();
  const [paymentsDetailsData, setPaymentsDetailsData] = useState<PaymentDetail[]>([]);
  const [dataPaymentsDetailsSelected, setDataPaymentsDetailsSelected] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fiscalXML, setFiscalXML] = useState<File>();
  const [fiscalQr, setFiscalQr] = useState<File>();
  const { GetFileById, GetFileIfExists, GetFiles } = useFiles();

  const { generatePDF } = PaymentsPDF();
  const { SavePdf, DeletePdf, DownloadPdf } = usePdf();

  const { EvaluateFormula, fetchParameters } = useFormulaEvaluator();

  const [parameters, setParameters] = useState()
  const [isBackdrop, setIsBackdrop] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [isResettingPdf, setIsResettingPdf] = useState(false);

  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);
  const id1 = open1 ? 'simple-popover' : undefined;
  const id2 = open2 ? 'simple-popover' : undefined;

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const getDataAndGeneratePDF = async (paymentsId: number) => {
    try {
      const response = await GenericGetReport(`/payments/pdf/${paymentsId}`, false);
      if (response.data.dataIssuingCompany.rpt_image) {
        const rptImageFile = await GenericGetResource(`/filessql/` + response.data.dataIssuingCompany.rpt_image);
        response.data.dataReceiptHeader.logoImage = rptImageFile?.data.data_file ?? undefined;
      }


      // if (response.data.dataPaymentHeader.qr_file) {
      //   const responseQR = await GetFileById(response.data.dataPaymentHeader.qr_file);
      //   const base64Part = responseQR?.dataURL.split(';base64,')[1];
      //   const newBase64 = `data:image/png;base64,${base64Part}`;
      //   response.data.dataPaymentHeader.fiscalQr = newBase64 ?? undefined;
      // }

      let pdfDoc = await generatePDF(response.data, parameters);
      return pdfDoc;
    } catch (error) {
      toast.error(`${t("generic.reports.PDF-generate-error")}`);
      console.log(error)
    }
  };

  const handleGenerateAndSavePDF = async () => {
    const paymentId = paymentLocal?.payment_id ?? 0;
    const fileName = paymentLocal?.payment_name;
    try {
      const pdfDoc = await getDataAndGeneratePDF(paymentId);
      const fileId = await SavePdf("Payments", paymentId, fileName, pdfDoc);
      if (paymentLocal) {
        paymentLocal.report_file_id = fileId
      }
      await onPutReportFileId()
    } catch (error) {
      toast.error(`${t("generic.reports.PDF-generate-error")}`);
      await onPutReportFileId()
    }
  };

  const onGeneratePDF = async () => {
    setIsBackdrop((prev) => true);
    setIsGeneratingPdf((prev) => true);
    setIsResettingPdf((prev) => true);
    const fileId = paymentLocal?.report_file_id;

    if (!fileId) {
      await handleGenerateAndSavePDF();
    } else {
      if (paymentLocal?.payment_name) {
        await DownloadPdf(fileId, paymentLocal.payment_name)
      }
    }
    setIsBackdrop((prev) => false);
    setIsGeneratingPdf((prev) => false);
    setIsResettingPdf((prev) => false);
  };

  const onResetPDF = async () => {
    setIsBackdrop((prev) => true);
    setIsGeneratingPdf((prev) => true);
    setIsResettingPdf((prev) => true);
    try {
      if (paymentLocal) {
        if (paymentLocal.report_file_id) {
          await DeletePdf(paymentLocal.report_file_id);
        }
        paymentLocal.report_file_id = undefined;
        await onGeneratePDF();
      }
    } catch (error: any) {
      toast.error(`${error}`);
    }
    setIsBackdrop((prev) => false);
    setIsGeneratingPdf((prev) => false);
    setIsResettingPdf((prev) => false);
  }

  const onPutReportFileId = async () => {
    if (paymentLocal) {
      await GenericPutResource(`/payments/${paymentLocal.payment_id}`, { report_file_id: paymentLocal.report_file_id })
        .then(async (response) => {
        })
        .catch((error) => {
          paymentLocal.report_file_id = undefined;
          toast.error(`${error.message}`);
        });
    }

  }

  const onCancelPayment = async (e: any) => {
    setIsLoading(true);

    await GenericPatchResource(`/payments/cancel/${paymentLocal?.payment_id}`,)
      .then(() => {
        Swal.fire({
          customClass: { container: "swalfire" },
          title: `${t("purchaseinvoices.info.already-canceled")}`,
          icon: "success",
          allowOutsideClick: false,
          confirmButtonColor: theme.palette.primary.main,
        }).then((result) => {
          if (result.isConfirmed) {
            setClickedButtonGoBack((prev) => !prev)
          }
        });
        setPaymentLocal((prev) => ({
          ...paymentLocal,
        }));
        setLoadedStampingInfo((prev) => !prev);
        setIsLoading(false);
        setOpenDialogView(false);
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
        setIsLoading(false);
      })
  }

  const onSendEmail = async () => {
    if (paymentLocal) {
      let paymentsDetailsData: any[] = []
      let mySupplier = await GenericGetResource(`/suppliers/${paymentLocal.supplier_id}`);
      paymentLocal.supplier_email = mySupplier.data.supplier_email;
      paymentsDetailsData.push({
        data: paymentLocal,
        status: (mySupplier.data.supplier_email) ? "Waiting" : "Error",
        status_description: (mySupplier.data.supplier_email) ? "generic.send_email.waiting" :
          "generic.send_email.no_email"
      })
      setDataPaymentsDetailsSelected((prev: any) => paymentsDetailsData);
      setOpenEmail(true);
    }
  }

  useEffect(() => {
    let myPromises = [
      GenericGetResource(`/payments/${paymentDetailPayload.payment_id ?? 0}`),
      GenericGetResource(`/paymentsdetails/bypaymentid/${paymentDetailPayload.payment_id}`),
    ]
    Promise.all(myPromises)
      .then(async (responses) => {
        responses[0] && setPaymentLocal(responses[0].data);
        responses[1] && setPaymentsDetailsData(responses[1].data.data);

        let myPermissions = [
          GetResourceByUrl(`/payments/pdf`),
          GetResourceByUrl(`/paymentsdetails/sendemail`),
          GetResourceByUrl(`/payments/cancel`),
          GetResourceByUrl(`/payments/resetpdf`),
        ];

        Promise.all(myPermissions)
          .then((responsesPermissions) => {
            responsesPermissions[0] && setResourceGeneratePdf(responsesPermissions[0]);
            responsesPermissions[1] && setResourceSendEmail(responsesPermissions[1]);
            responsesPermissions[2] && setResourceCancelPayment(responsesPermissions[2]);
            responsesPermissions[3] && setResourceResetPdf(responsesPermissions[3]);
          });

        if (!responses[0].data.xml_file_id || !responses[0].data.qr_file) {
          try {
            const response = await GenericPatchResource(`/payments/fiscalsignature/${paymentDetailPayload.payment_id}`);

            if (response.data.XML !== undefined && response.data.QR !== undefined) {
              const files = {
                qr_file: response.data.QR,
                xml_file_id: response.data.XML
              };

              await GenericPutResource(`/payments/${paymentDetailPayload.payment_id}`, files);

              const responseFiles = await GetFiles(response.data.payment_id, "Payments");

              if (responseFiles && responseFiles.length > 0) {
                responseFiles.forEach(async (element) => {
                  if (element.file_id === (response.data.XML ?? 0)) {
                    await setFiscalXML(element);
                  }
                  if (element.file_id === (response.data.QR ?? 0)) {
                    await setFiscalQr(element);
                  }
                });
              }

            }
          } catch (error) {
            // ** When we are able to save files uncomment this line to send the snackbar when it cannot be saved. **
            // showSnackBar(t("generic.snackbar.try_to_save_files"), "warning");
          }
        }
        setParameters(await fetchParameters());
        setDataLoaded(true);
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
      })
  }, []);

  return (
    <>
      {!dataLoaded && <Spinner isBox={false} />}
      {dataLoaded &&
        <>
          {isBackdrop &&
            <Backdrop
              sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
              open={isBackdrop}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          }
          <Header
            title={t("payments.title-view")}
            child={
              <div className='d-flex flex-row-reverse align-items-center'>
                <div>
                  <Button variant="outlined" aria-describedby={id2} onClick={handleClick2}>
                    <MoreHorizIcon />
                  </Button>
                  <Popover
                    id={id2}
                    open={open2}
                    anchorEl={anchorEl2}
                    onClose={handleClose2}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    sx={{ minWidth: 200 }}
                  >
                    <ListItemButton onClick={() => { setOpenDialogCancelPayment(true); }} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', minWidth: 200 }} disabled={resourceCancelPayment ? !resourceCancelPayment?.create : true}>
                      {t("payments.actions.cancel")}<CancelPresentationIcon />
                    </ListItemButton>
                    <ListItemButton onClick={() => { onSendEmail(); }} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', minWidth: 200 }} disabled={!resourceSendEmail?.create}>
                      {t("purchaseinvoices.actions.sendemail")}<EmailIcon />
                    </ListItemButton>
                  </Popover>
                </div>
                <div>
                  <Button variant='outlined' aria-describedby={id1} onClick={handleClick1}>
                    <PrintIcon />
                  </Button>
                  <Popover
                    id={id1}
                    open={open1}
                    anchorEl={anchorEl1}
                    onClose={handleClose1}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    sx={{ minWidth: 200 }}
                  >
                    <ListItemButton onClick={() => { onGeneratePDF(); }} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', minWidth: 200 }} disabled={((resourceGeneratePdf) ? !resourceGeneratePdf?.read : true) || isGeneratingPdf }>
                      {t("generic.reports.download-PDF")}<PictureAsPdfIcon />
                    </ListItemButton>
                    <ListItemButton onClick={() => { onResetPDF(); }} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', minWidth: 170 }} disabled={((resourceResetPdf) ? !resourceResetPdf?.read : true) || isResettingPdf}>
                      {t("generic.reports.reset-PDF")}<AutorenewIcon />
                    </ListItemButton>
                  </Popover>
                </div>
                <Button variant="outlined" onClick={() => { setOpenDialogView(false); setClickedButtonGoBack((prev) => !prev) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />

          {permissionsPayments?.read &&
            <>
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column w-50">
                  <Typography style={{ fontWeight: "bold" }}>{t("suppliers.title-view")}:</Typography>
                  <Typography>{paymentLocal?.supplier_business_name}</Typography>
                  <Typography>{paymentLocal?.supplier_rfc}</Typography>
                  <Typography>{paymentLocal?.supplier_tax_regime_code} - {paymentLocal?.supplier_tax_regime_description}</Typography>
                  <Box sx={{ paddingRight: 1, marginBottom: 0.5 }}>
                    <Divider />
                  </Box>
                  <div className="d-flex w-100 pt-2">
                    <TextField
                      variant="filled"
                      label={`${t("payments.fields.payment_name")}`}
                      value={paymentLocal?.payment_name}
                      size="small"
                      sx={{ width: "100%", paddingRight: 1 }}
                      InputProps={{ readOnly: true, disableUnderline: true }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column-reverse w-50">
                  <div className="d-flex">
                    <TextField
                      sx={{ width: "60%", paddingRight: 1 }}
                      variant="filled"
                      label={`${t("payments.fields.total_amount")}`}
                      value={setFormatNumber({ value: paymentLocal?.total_amount ?? 0, decimals: 4 })}
                      size="small"
                      InputProps={{ readOnly: true, disableUnderline: true }}
                    />
                    <TextField
                      sx={{ width: "40%" }}
                      label={`${t("currencies.title-view")}`}
                      variant="filled"
                      value={`${paymentLocal?.currency_code ?? ''} - ${paymentLocal?.currency_description ?? ''}`}
                      size="small"
                      InputProps={{ readOnly: true, disableUnderline: true }}
                    />
                  </div>
                  <Box sx={{ width: "100%" }} className="d-flex custom-card-view mb-2">
                    <Box className="w-100">
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                            {t("bankaccounts.fields.account_alias")}:
                          </Typography>
                          {paymentLocal?.company_account_alias}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                            {t("bankaccounts.fields.bank_references")}:
                          </Typography>
                          {paymentLocal?.company_bank_references}
                        </Typography>
                        <Box sx={{ display: "flex" }}>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("bankaccounts.fields.bank_name")}:
                            </Typography>
                            {paymentLocal?.company_bank_name}
                          </Typography>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("currencies.title-view")}:
                            </Typography>
                            {paymentLocal?.company_bank_currency_description} - {paymentLocal?.company_bank_currency_code}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("bankaccounts.fields.card_number")}:
                            </Typography>
                            {paymentLocal?.company_bank_card_number}
                          </Typography>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("bankaccounts.fields.account_number")}:
                            </Typography>
                            {paymentLocal?.company_account_number}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} width={"55%"} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("bankaccounts.fields.interbank_key")}:
                            </Typography>
                            {paymentLocal?.company_bank_interbank_key}
                          </Typography>
                          <Typography fontFamily={"sans-serif"} fontSize={12} sx={{ display: "flex" }} paddingRight={1}>
                            <Typography fontWeight={"bold"} fontSize={12} marginRight={1}>
                              {t("bankaccounts.fields.swift_code")}:
                            </Typography>
                            {paymentLocal?.company_bank_swift_code}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </div>
              </div>

              <Divider />

              <div className="d-flex">
                <TextField
                  label={`${t("paymentmethods.title-view")}`}
                  variant="filled"
                  value={`${paymentLocal?.payment_method_code ?? ''} - ${paymentLocal?.payment_method_name ?? ''}`}
                  sx={{ width: "50%", paddingRight: 1 }}
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  size='small'
                />
                <div className="w-50">
                  <TextField
                    label={`${t("payments.fields.payment_date")}`}
                    variant="filled"
                    value={TimeConverter(paymentLocal?.payment_date?.toString())}
                    sx={{ width: "60%", paddingRight: 1 }}
                    InputProps={{ readOnly: true, disableUnderline: true }}
                    size='small'
                  />
                  <TextField
                    label={`${t("payments.fields.exchange_rate")}`}
                    variant="filled"
                    value={setFormatNumber({ value: (paymentLocal?.exchange_rate ?? paymentsDetailsData[0].exchange_rate ?? 0), decimals: 4 })}
                    sx={{ width: "40%" }}
                    InputProps={{ readOnly: true, disableUnderline: true }}
                    size='small'
                  />
                </div>
              </div>
              <Divider />
              <Box className="d-flex w-100">
                <Box sx={{ width: "50%" }} className="d-flex custom-card-view">
                  <Box className="w-100 d-flex flex-column">
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography fontWeight={"bold"} fontSize={20} marginRight={1}>
                        {t("purchaseinvoices.fields.account_deposit")}:
                      </Typography>
                      <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                        <Typography fontWeight={"bold"} marginRight={1}>
                          {t("bankaccounts.fields.account_alias")}:
                        </Typography>
                        {paymentLocal?.supplier_account_alias}
                      </Typography>
                      <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                        <Typography fontWeight={"bold"} marginRight={1}>
                          {t("bankaccounts.fields.bank_references")}:
                        </Typography>
                        {paymentLocal?.supplier_bank_references}
                      </Typography>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.bank_name")}:
                          </Typography>
                          {paymentLocal?.supplier_bank_name}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("currencies.title-view")}:
                          </Typography>
                          {paymentLocal?.supplier_bank_currency_description} - {paymentLocal?.supplier_bank_currency_code}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.card_number")}:
                          </Typography>
                          {paymentLocal?.supplier_bank_card_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.account_number")}:
                          </Typography>
                          {paymentLocal?.supplier_account_number}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"55%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.interbank_key")}:
                          </Typography>
                          {paymentLocal?.supplier_bank_interbank_key}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.swift_code")}:
                          </Typography>
                          {paymentLocal?.supplier_bank_swift_code}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <TextField
                        variant="filled"
                        label={`${t("payments.fields.commission")}`}
                        value={setFormatNumber({ value: paymentLocal?.commission ?? 0, decimals: 4 })}
                        size="small"
                        sx={{ width: "50%", paddingRight: 1 }}
                        InputProps={{ readOnly: true, disableUnderline: true }}
                      />
                      <TextField
                        variant="filled"
                        label={`${t("payments.fields.commission_currency")}`}
                        value={`${paymentLocal?.commission_currency_code ? `${paymentLocal?.commission_currency_code} - ${paymentLocal?.commission_currency_description}` : ""}`}
                        size="small"
                        sx={{ width: "50%", paddingRight: 1 }}
                        InputProps={{ readOnly: true, disableUnderline: true }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ width: "1%" }} display={"flex"} justifyContent={"center"}>
                  <Divider />
                </Box>
                <Box sx={{ width: "50%" }} className="d-flex custom-card-view">
                  <Box className="w-100 d-flex flex-column">
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography fontWeight={"bold"} fontSize={20} marginRight={1}>
                        {t("purchaseinvoices.fields.account_pay")}:
                      </Typography>
                      <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                        <Typography fontWeight={"bold"} marginRight={1}>
                          {t("bankaccounts.fields.account_alias")}:
                        </Typography>
                        {paymentLocal?.intermediary_account_alias}
                      </Typography>
                      <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                        <Typography fontWeight={"bold"} marginRight={1}>
                          {t("bankaccounts.fields.bank_references")}:
                        </Typography>
                        {paymentLocal?.intermediary_bank_references}
                      </Typography>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.bank_name")}:
                          </Typography>
                          {paymentLocal?.intermediary_bank_name}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("currencies.title-view")}:
                          </Typography>
                          {paymentLocal?.intermediary_bank_currency_description} - {paymentLocal?.intermediary_bank_currency_code}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"50%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.card_number")}:
                          </Typography>
                          {paymentLocal?.intermediary_bank_card_number}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.account_number")}:
                          </Typography>
                          {paymentLocal?.intermediary_account_number}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} width={"55%"} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.interbank_key")}:
                          </Typography>
                          {paymentLocal?.intermediary_bank_interbank_key}
                        </Typography>
                        <Typography fontFamily={"sans-serif"} sx={{ display: "flex" }} paddingRight={1}>
                          <Typography fontWeight={"bold"} marginRight={1}>
                            {t("bankaccounts.fields.swift_code")}:
                          </Typography>
                          {paymentLocal?.intermediary_bank_swift_code}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Divider />
            </>
          }

          <DialogPaymentDetail
            Payment={
              permissionsPaymentsDetails?.read &&
              <TabRelatedDocuments
                paymentsDetailsData={paymentsDetailsData}
              />
            }
            Stamping={
              permissionsPayments?.read && (loadedStampingInfo || !loadedStampingInfo) &&
              <StampingPayment
                paymentLocal={paymentLocal}
                setPaymentLocal={setPaymentLocal}
                isEdit={(paymentLocal?.payment_id && paymentLocal.payment_id != 0) ? false : true}
              />
            }
            Statuses={
              <TabStatuses paymentsDetailsData={paymentsDetailsData} />
            }
          />
          <DialogCancelPayment
            open={openDialogCancelPayment}
            setOpen={setOpenDialogCancelPayment}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onAcept={onCancelPayment}
          />
          <DialogSendEmailPayment
            open={openEmail}
            setOpen={setOpenEmail}
            dataPaymentsDetailsSelected={dataPaymentsDetailsSelected}
            paymentLocal={paymentLocal}
            setPaymentLocal={setPaymentLocal}
          />
        </>
      }
      <SnackbarComponent />
    </>
  )
}
